// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridPivot.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridPivot component
 */
!(function() {
  const { map, flow, max, min, sumBy, times, identity, filter } = require('lodash/fp');
  var markFromTo = function(columnDataObjects) {
    var from = 0;

    return map(function(columnDataObject) {
      var to = from + columnDataObject.pivotColumn;
      var result = {
        from: from,
        to: to,
        columnDataObject: columnDataObject
      };

      from = to;
      return result;
    }, columnDataObjects);
  };

  var breakPageFromTo = function(mappingData, pageFrom, pageTo) {
    return flow(
      filter(function(item) {
        return !(item.to <= pageFrom || pageTo <= item.from);
      }),
      map(function(item) {
        return {
          from: max([pageFrom - item.from, 0]),
          to: min([item.columnDataObject.pivotColumn, pageTo - item.from]),
          columnDataObject: item.columnDataObject
        };
      })
    )(mappingData);
  };

  var breakChildrenColumn = function(columnDataObject, pageFrom, pageTo) {
    var mappingColumnDataObject = markFromTo(columnDataObject.childs);

    return breakPageFromTo(mappingColumnDataObject, pageFrom, pageTo);
  };

  var breakPage = function(columnDataObjects, pivotColumnsPerExportedPage) {
    var totalPivotColumn = sumBy('pivotColumn', columnDataObjects);
    var totalPage = Math.ceil(totalPivotColumn / pivotColumnsPerExportedPage);

    var mappingColumnDataObject = markFromTo(columnDataObjects);
    var findPage = flow(
      times(identity),
      map(function(pageIndex) {
        var pageFrom = pageIndex * pivotColumnsPerExportedPage;
        var pageTo = (pageIndex + 1) * pivotColumnsPerExportedPage;

        return breakPageFromTo(mappingColumnDataObject, pageFrom, pageTo);
      })
    )(totalPage);

    return findPage;
  };

  module.exports = {
    breakPage: breakPage,
    breakChildrenColumn: breakChildrenColumn
  };
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.PivotExportingUtils.js